import { ifSelectorExist, getElement, getElements } from './utils';

export const tabsLocations = () => {
    let tabs = getElements('.tab_item'),
        tabsContent = getElements('.tab_content'),
        tabsParent = getElement('.tab_parent');

    if (ifSelectorExist(tabs) && ifSelectorExist(tabsContent) && ifSelectorExist(tabsParent)) {
        let hideTabContent = () => {
            tabsContent.forEach(element => {
                element.classList.add('not-visible');
            });
    
            tabs.forEach(element => {
                element.classList.remove('tab_active')
            });
        };
    
        let showTabContent = (i = 0) => {
            tabsContent[i].classList.remove('not-visible')
            tabs[i].classList.add('tab_active');
        };
        
        tabsParent.addEventListener('click', (event) => {
            const target = event.target;
    
            if (target && target.classList.contains('tab_item')) {
                tabs.forEach((element, i) => {
                    if (target == element) {
                        hideTabContent();
                        showTabContent(i);
                    };
                });
            };
        });

        hideTabContent();
        showTabContent();
    }
}
